/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */

/**
 * Checks if the clicked element is part of an IVPickList component
 * @param {Event} event - The DOM event (typically mousedown)
 * @param {React.RefObject} picklistRef - Reference to the picklist component
 * @returns {boolean} - True if the click is inside any part of the IVPickList
 */
export const isClickInsideIVPickList = (event, picklistRef) => {
    return (
        event.target.closest('.picklist-pulldown-menu-item') ||
        event.target.closest('.picklist-pulldown-menu') ||
        event.target.closest('.picklist-pulldown-menu-scroll') ||
        event.target.closest('.picklist-pulldown-menu-container') ||
        event.target.closest('.picklist-pulldown-menu-open') ||
        event.target.closest('.picklist-done') ||
        picklistRef?.current?.drugInputFieldRef?.current?.contains(event.target)
    );
};

/**
 * Determines if the clicked element is a menu item within the Neofax menu item.
 *
 * @param {Event} event - The DOM event (typically mousedown or click).
 * @param {string} prefix - The prefix used to identify the Neofax menu item class.
 * @returns {Element|null} - The closest matching element or null if none is found.
 */
export const isNeofaxMenuItem = (event, prefix) => {
    return event.target.closest(`.${prefix}--header__menu-item`);
}
